import { render, staticRenderFns } from "./OfferStackedInverse.vue?vue&type=template&id=5e2e54d1&scoped=true&"
import script from "./OfferStackedInverse.vue?vue&type=script&lang=js&"
export * from "./OfferStackedInverse.vue?vue&type=script&lang=js&"
import style0 from "./OfferStackedInverse.vue?vue&type=style&index=0&id=5e2e54d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2e54d1",
  null
  
)

export default component.exports